export const packages = [
    {
      id: 1,
      title: 'Membership',
      description:
        'Our Small Group Training pairs expert coaching with the team spirit of a tight team. In groups of 4-6, you’ll tackle sport-specific circuits, exercise techniques, and goal-driven workouts designed to help you become a better athlete. Enjoy personalized feedback, friendly competition, and a supportive atmosphere.',
      price: '899 SEK/Month',
      features: [
        'Small group training, 6 sessions a month',
        '2 Basic screenings per year',
        'Binding time: 2 months',
        'Notice period: 1 month',
      ],
      type: 'membership',
      image: '/new/offer1.jpg',
    },
    {
      id: 2,
      title: 'Group Training',
      price: '250 SEK/session',
      description:
      'Our Small Group Training pairs expert coaching with the team spirit of a tight team. In groups of 4-6, you’ll tackle sport-specific circuits, exercise techniques, and goal-driven workouts designed to help you become a better athlete. Enjoy personalized feedback, friendly competition, and a supportive atmosphere. Join our group sessions and level up together—reserve your spot now!',
      features: [
        'Small group training',
        'Flexible scheduling',
        'Professional coaching',
        'Motivational environment',
      ],
      image: '/new/offer6.jpg',
    },
    {
      id: 3,
      title: 'Personal Coaching 1',
      price: '599 SEK/session',
      description:
        'Our Personal coaching sessions with our coaches deliver customized workout plans, one-on-one coaching, and training guidance tailored to your goals. We help you track your progress through regular meetings, receive ongoing accountability, and tap into expert support every step of the way. Ready to transform? Book your free assessment today and start your journey to peak performance!',
      features: [
        '1-9 personal coaching sessions with a coach',
        'Customized training programs',
        'Progress tracking & analytics',
        'Flexible scheduling',
      ],
      image: '/new/offer2.jpg',
    },
    {
      id: 4,
      title: 'Personal Coaching 2',
      price: '500 SEK/Session',
      description:
        'Our Personal coaching sessions with our coaches deliver customized workout plans, one-on-one coaching, and training guidance tailored to your goals. We help you track your progress through regular meetings, receive ongoing accountability, and tap into expert support every step of the way. Ready to transform? Book your free assessment today and start your journey to peak performance!',
      features: [
        '10 personal coaching sessions with a coach',
        'Comprehensive training programs',
        'Detailed progress tracking',
        'Priority scheduling',
      ],
      image: '/new/offer4.jpg',
    },
    {
      id: 5,
      title: 'Basic Screening + Training Program',
      price: '1200 SEK',
      description:
        'Our Private Training offers personalized, one-on-one coaching tailored to your specific goals, whether it’s improving strength, speed, or sport-specific skills. Work directly with our expert coaches to create a customized plan that maximizes your potential. Ready to take your training to the next level? Book your private session now!',
      features: [
        'Comprehensive fitness assessment',
        'Personalized training program',
        'Expert coaching guidance',
        'Progress monitoring',
      ],
      image: '/new/offer5.jpg',
    },
  ];